import { makeVar } from "@apollo/client";

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function makeVar called at module scope is not allowed. This may cause unwanted side effects. */
const selectedApp = makeVar("");

export function getSelectedApp(): string {
    return selectedApp();
}

export function setSelectedApp(app: string): void {
    selectedApp(app);
}
